<ng-content select="[prependLabel]" />
<ng-content select="input" />
<label
  [class.fw-bold]="boldLabel"
  [for]="id"
  [ngClass]="labelClassesInner">
  @if (label) {
    <span [ngClass]="labelContentClassesInner">
      @if (isString(label)) {
        {{ label }}
      } @else {
        <ng-container
          [ngTemplateOutlet]="$any(label)"
          [ngTemplateOutletContext]="{ $implicit: context }" />
      }
    </span>
  }

  @if (required) {
    <span class="mbs-form_label-required">*</span>
  }

  @if (info) {
    <span
      class="fa fa-info-circle tooltip-btn mb-1 ml-1 text-lg text-cyan"
      [container]="infoContainer"
      [placement]="infoPlacement"
      [ngbTooltip]="info"
      [triggers]="infoTriggers"></span>
  }

  @if (description) {
    <div [ngClass]="descriptionClasses">
      {{ description }}
    </div>
  }
</label>
<ng-content select="[appendLabel]" />
